import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Header } from 'pages/Header';
import { Footer } from 'pages/Footer';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import "./style.sass";
import { useServices } from 'hooks/useServices';
import { useIsMobile } from 'hooks/useIsMobile';
import SlidersEmarsys from 'components/Emarsys/SlidersEmarsys/index_product';
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';


export function ActivarPermisosIncode({onTryAgain}) {

    const history = useHistory();
    const { isMobile } = useIsMobile();


    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Before Start  Credit-Page');
        window.ineum('meta', 'portal', 'Credito CS');
        window.scrollTo(0, 0);
    }, [])

    
    return (
        <div className={isMobile === "desktop" ? "" : "homeMobile"}>
            {isMobile === "desktop"
                ? <Header type="complete" />
                : <HeaderMobileCredito title={""} type="backFull" />
            }
            <main className='nuevoCredito'>
                <section className="sectionPrincipalBeneficios incode-comenzar">
                    <div className="contenido">
                        <div className="contenedorLandingBeneficios">

                            <div className=''>

                                <div className='contentImage'>
                                    <div className="boxImage permisos">
                                        <img src={`${BASE_PATH}${SUB_DIRECTORY}/img/img_permisos.png`} className="img" alt="banner-principal" />
                                    </div>
                                </div> 
                                
                                <div className='subt'>
                                    <h1 className='bold fontsize22'>Permisos</h1>
                                </div>

                                <p className='top'>
                                    Necesitamos acceso a la cámara para escanear tu documento. 
                                    Recuerda que siempre puedes cambiar esto en la configuración de tu dispositivo.
                                </p>
                                                        

                            </div>
                        </div>
                    </div>
                </section>
                <div className="boxBtnSolicitar marginBottom30">
                    <button className="btnSolicitar" onClick={onTryAgain}>Dar acceso</button>
                </div>
            </main>
        </div>
    )
}